import type {SVGProps, VoidFunctionComponent} from 'react';

export const ChevronRightIcon: VoidFunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16' {...props}>
        <path fill='currentColor' d='M5.727 11.053 8.78 8 5.727 4.94l.94-.94 4 4-4 4-.94-.947Z' />
    </svg>
);
